import React from "react";
import "./form.style.css";

const Form = (props) => {
  return (
    <div className="container h-100">
      <div>{props.error ? error() : ""}</div>
      <form action="" onSubmit={props.loadweather}>
        <div className="row">
          <div className="col-md-4 mt-1 offset-md-3">
            <input
              type="text"
              className="form-control"
              name="city"
              autoComplete="off"
              placeholder="Search for City..."
            />
          </div>
          {/* <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              name="country"
              autoComplete="off"
              placeholder="Country"
            />
          </div> */}
          <div className="col-md-3 mt-md-0 mt-4 py-2 text-md-left">
            <button className="btn btn-outline-warning">Get Weather</button>
          </div>
        </div>
      </form>
    </div>
  );
};

function error() {
  return (
    <div className="alert alert-danger mx-2" role="alert">
      Please Enter a Valid City
    </div>
  );
}

export default Form;
